import { useRoute } from "@react-navigation/native";
import type { NativeStackScreenProps } from "@react-navigation/native-stack";
import { observer } from "mobx-react-lite";
import type React from "react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Image, XStack, YStack } from "tamagui";
import { useStores } from "../../core/stores";
import { usePlanNavigation } from "../../plans/usePlanNavigation";
import { Body } from "../Body";

export const UserSelectHeader: React.FC = observer(() => {
  const { t } = useTranslation();
  const { plansStore } = useStores();
  const route =
    useRoute<
      NativeStackScreenProps<ReactNavigation.RootParamList, "Module">["route"]
    >();
  const navigation = usePlanNavigation();

  const plan = plansStore.byId.get(route.params.planUid);

  useEffect(() => {
    if (plan?.title) {
      navigation.setOptions({ title: `${plan.title} - Select user` });
    }
  }, [plan?.title, navigation]);

  if (!plan) {
    return null;
  }

  return (
    <YStack gap="$medium" backgroundColor={"$primary"} padding="$space.large">
      <XStack gap="$small">
        <Image
          objectFit="contain"
          height={32}
          width={171}
          source={require("../../../assets/planira.png")}
        />
      </XStack>
      <Body>{t("home_intro_1")}</Body>
    </YStack>
  );
});
